<template>
	<div>
		<v-spacer></v-spacer>
		<div class="container-acc">
			<div class="acc">
				<div class="acc-group">
					<p>Kontrast:</p>
					<v-btn
						color="#0052A5"
						class="contrast-normal-button"
						aria-hidden="true"
						title="kontrast domyślny"
						@click="$messagesBus.$emit('setContrast', 'normal')"
					>A</v-btn>
					<v-btn
						color="#1B1B1B"
						class="contrast-high-button"
						aria-hidden="true"
						title="kontrast czarno-biały"
						@click="$messagesBus.$emit('setContrast', 'high')"
					>A</v-btn>
				</div>
				<div class="acc-group">
					<p>Czcionka:</p>
					<v-btn
						color="primary"
						class="normal-font-button"
						aria-hidden="true"
						title="czcionka domyślna"
						@click="$messagesBus.$emit('setFontSize', 'normal'); setActiveBtn('normal')"
					>A</v-btn>
					<v-btn
						color="#primary"
						class="medium-font-button"
						aria-hidden="true"
						title="czcionka średnia"
						v-bind:class="{active: activeMediumBtn}"
						@click="$messagesBus.$emit('setFontSize', 'medium'); setActiveBtn('medium')"
					>A+</v-btn>
					<v-btn
						color="#primary"
						class="large-font-button"
						aria-hidden="true"
						title="czcionka duża"
						v-bind:class="{active: activeLargeBtn}"
						@click="$messagesBus.$emit('setFontSize', 'large'); setActiveBtn('large');"
					>A++</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AccesibilityToolbar",
		data() {
			return {
				activeNormalBtn: false,
				activeMediumBtn: false,
				activeLargeBtn: false
			};
		},
		methods: {
			setActiveBtn(size) {
				if (size === "normal") {
					this.activeNormalBtn = true;
					this.activeMediumBtn = false;
					this.activeLargeBtn = false;
				}
				if (size === "medium") {
					this.activeNormalBtn = false;
					this.activeMediumBtn = true;
					this.activeLargeBtn = false;
				}
				if (size === "large") {
					this.activeNormalBtn = false;
					this.activeMediumBtn = false;
					this.activeLargeBtn = true;
				}
			}
		}
	};
</script>

<style scoped>

.v-btn {
  height: 40px !important;
}

.polish-logo {
  display: flex !important;
  align-items: flex-end;
}

.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  margin-bottom: 0;
}

.container-acc {
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
}

.acc-group .v-btn[data-v-65c515e0] {
  margin-right: 15px;
}

.container-acc p {
  font-size: 1.5em;
  margin-right: 15px;
  vertical-align: middle;
}

.acc {
  flex-grow: 5;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.acc-group {
  display: flex;
  font-size: 0.75em;
  color: #0052a5;
  margin-right: 40px;
}
.acc-group:last-child {
  margin-right: 10px;
}

.acc-group p {
  margin: auto 0;
  padding-right: 15px;
}

.acc-group a {
  text-decoration: none;
}

.v-btn {
  color: #fff;
}

.acc-group:not(:last-child) {
  margin-right: 30px;
}

.acc-group span {
  padding-top: 5px;
  margin-right: 15px;
}

.acc-group i,
.acc-group a {
  width: 50px;
  height: 40px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}

.acc-group a:last-child {
  border: solid 1px white;
}

.theme--dark .acc-group p[data-v-65c515e0] {
  color: #fff;
}

.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: #0052a5;
}

.application.theme--dark
  .acc
  .acc-group
  .contrast-high-button[data-v-65c515e0]:not(.v-btn--depressed):not(.v-btn--flat) {
  background-color: yellow !important;
}

.application.theme--dark
  .acc
  .acc-group
  .contrast-high-button[data-v-65c515e0]:not(.v-btn--depressed):not(.v-btn--flat) .v-btn__content {
  color: #000 !important;
}

.application.theme--dark
  .acc
  .acc-group
  .contrast-high-button[data-v-65c515e0]:not(.v-btn--depressed):not(.v-btn--flat)
  .v-btn__content {
  color: #000 !important;
}

.application.theme--dark
  .acc
  .acc-group
  .contrast-high-button:not(.v-btn--depressed):not(.v-btn--flat) .v-btn__content {
  color: red;
}

.aParent div {
  float: left;
  clear: none;
}

.application.theme--dark .acc .acc-group .v-btn__content {
  color: #000;
}

.v-toolbar p {
	font-weight: normal;
}

</style>
